export default "<h1>NotFound404</h1>\n";